<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4134"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4138"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4148"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4146" /></clipPath></defs><g
     id="g4140"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4142"><g
         id="g4144"
         clip-path="url(#clipPath4148)"><g
           id="g4150"
           transform="translate(10,356.6738)"><path
             d="M 0,0 H 156.895 455.519"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4152" /></g><g
           id="g4154"
           transform="translate(93.5068,399.2275)"><path
             d="M 0,0 C 13.096,0 23.782,10.652 23.782,23.741 23.782,36.83 13.096,47.482 0,47.482 -13.067,47.482 -23.754,36.83 -23.754,23.741 -23.754,10.652 -13.067,0 0,0 Z"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4156" /></g><g
           id="g4158"
           transform="translate(299.9502,446.71)"><path
             d="m 0,0 h 89.46 c 13.067,0 23.754,-10.681 23.754,-23.741 0,-13.061 -10.687,-23.741 -23.754,-23.741 H 0 c -13.067,0 -23.754,10.68 -23.754,23.741 C -23.754,-10.681 -13.067,0 0,0 Z"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4160" /></g><g
           id="g4162"
           transform="translate(181.209,399.2275)"><path
             d="M 0,0 C 13.096,0 23.782,10.652 23.782,23.741 23.782,36.83 13.096,47.482 0,47.482 -13.067,47.482 -23.754,36.83 -23.754,23.741 -23.754,10.652 -13.067,0 0,0 Z"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4164" /></g><g
           id="g4166"
           transform="translate(162.416,279.7559)"><path
             d="M 0,0 -20.013,-83.747"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4168" /></g><g
           id="g4170"
           transform="translate(208.5068,203.5732)"><path
             d="m 0,0 28.317,31.788 c 1.247,1.388 1.247,3.654 0,5.042 L 0,68.618"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4172" /></g><g
           id="g4174"
           transform="translate(96.3135,203.5732)"><path
             d="m 0,0 -28.317,31.788 c -1.248,1.388 -1.248,3.654 0,5.042 L 0,68.618"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4176" /></g><g
           id="g4178"
           transform="translate(404.5186,235.5596)"><path
             d="m 0,0 c 10.941,-2.437 21.174,-6.743 30.387,-12.522 l 8.192,8.159 c 4.847,4.873 12.812,4.873 17.688,0 l 12.897,-12.891 c 4.875,-4.873 4.875,-12.834 0,-17.679 L 61,-43.12 c 5.755,-9.123 10.006,-19.266 12.473,-30.088 h 11.479 c 6.889,0 12.529,-5.638 12.529,-12.494 v -18.274 c 0,-6.855 -5.64,-12.493 -12.529,-12.493 H 73.416 C 70.949,-127.235 66.698,-137.321 61,-146.387 l 8.164,-8.159 c 4.875,-4.873 4.875,-12.834 0,-17.679 l -12.897,-12.919 c -4.876,-4.873 -12.841,-4.873 -17.688,0 l -8.192,8.16 c -9.099,-5.723 -19.219,-9.973 -30.047,-12.438 v -11.615 c 0,-6.885 -5.641,-12.523 -12.5,-12.523 h -18.283 c -6.861,0 -12.501,5.638 -12.501,12.523 v 11.643 c -10.772,2.437 -20.891,6.715 -29.991,12.41 l -8.163,-8.16 c -4.876,-4.873 -12.84,-4.873 -17.688,0 l -12.925,12.919 c -4.848,4.845 -4.848,12.806 0,17.679 l 8.191,8.159 c -5.725,9.066 -9.977,19.152 -12.443,29.918 h -11.594 c -6.887,0 -12.501,5.638 -12.501,12.493 v 18.274 c 0,6.856 5.614,12.494 12.501,12.494 h 11.566 c 2.437,10.709 6.633,20.738 12.273,29.776 l -8.22,8.244 c -4.875,4.845 -4.875,12.806 0,17.679 l 12.897,12.891 c 4.876,4.873 12.841,4.873 17.688,0 l 8.135,-8.103 c 9.072,5.751 19.162,10.03 29.934,12.551 v 11.53 c 0,6.885 5.612,12.523 12.5,12.523 h 18.255 C -5.641,23.883 0,18.245 0,11.36 Z"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4180" /></g><g
           id="g4182"
           transform="translate(383.2305,192.2412)"><path
             d="m 0,0 c 28.459,0 51.533,-23.062 51.533,-51.534 0,-28.445 -23.074,-51.506 -51.533,-51.506 -28.487,0 -51.562,23.061 -51.562,51.506 C -51.562,-23.062 -28.487,0 0,0 Z"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4184" /></g><g
           id="g4186"
           transform="translate(106.4326,119.0908)"><path
             d="M 0,0 H -59.187 C -79.651,0 -96.433,20.029 -96.433,44.479 V 326.43 c 0,24.477 16.752,44.479 37.246,44.479 h 43.143 337.884 c 20.494,0 37.246,-20.03 37.246,-44.479 V 107.374 M 170.529,0 H 89.375"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4188" /></g><g
           id="g4190"
           transform="translate(151.2197,119.0908)"><path
             d="M 0,0 H 0.198"
             style="stroke:#000000;stroke-width:20.176;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4192" /></g></g></g></g></svg>
</template>
